import { useEffect, useState } from "react";

import ApiHttp from "byzantine/src/ApiHttp";

export interface InvoiceUploadConfig {
  allowed_mime_types: string[];
  max_size_bytes: number;
  max_pages: number;
}

// fallback
export const DEFAULT_INVOICE_UPLOAD_CONFIG: InvoiceUploadConfig = {
  allowed_mime_types: [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif",
  ],
  max_size_bytes: 20 * 1024 * 1024,
  max_pages: 25,
};

// Fetches the server config, falling back to DEFAULT_INVOICE_UPLOAD_CONFIG while
// loading or on failure. Always returns a usable config — never null.
export const useInvoiceUploadConfig = (): InvoiceUploadConfig => {
  const [config, setConfig] = useState<InvoiceUploadConfig>(
    DEFAULT_INVOICE_UPLOAD_CONFIG
  );

  useEffect(() => {
    let cancelled = false;

    ApiHttp.fetch<InvoiceUploadConfig>("invoices/config/", { method: "GET" })
      .then((data) => {
        if (!cancelled) setConfig(data);
      })
      .catch(() => {
        // Keep the fallback config in place.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return config;
};
